import React from 'react'

import { TableViewCellTitle as Title, TableViewCellTitleContent } from '../StyledComponents/Settings'


const TableViewCellTitle = props => (
    <Title {...props}>
        <TableViewCellTitleContent>{props.text}</TableViewCellTitleContent>
    </Title>
)

export default TableViewCellTitle



// WEBPACK FOOTER //
// ./src/components/Settings/TableViewCellTitle.js